import { strings } from "../../localization";

export const DATE_PICKER_OPTIONS = [
    { value: 'today', label: strings.date_picker_options_today_label },
    { value: '24hour', label: strings.date_picker_options_24hour_label },
    { value: '48hour', label: strings.date_picker_options_48hour_label },
    { value: 'week', label: strings.date_picker_options_week_label },
    { value: '2weeks', label: strings.date_picker_options_2weeks_label },
    { value: 'month', label: strings.date_picker_options_month_label },
    { value: 'custom', label: strings.date_picker_options_custom_label }
];

export const DATE_DISPLAY_OPTIONS = [
    { value: 'today', label: strings.date_display_options_today_label },
    { value: '24hour', label: strings.date_display_options_24hour_label },
    { value: '48hour', label: strings.date_display_options_48hour_label },
    { value: 'week', label: strings.date_display_options_week_label },
    { value: '2weeks', label: strings.date_display_options_2weeks_label },
    { value: 'month', label: strings.date_display_options_month_label },
    { value: 'custom', label: strings.date_display_options_custom_label }
];

export const COACHING_REVIEW_EVENTS_DATE_PICKER_OPTIONS = [
    {
        label: strings.date_picker_options_today_label,
        value: 'today',
        checked: false
    },
    {
        label: strings.date_picker_options_24hour_label,
        value: '24hour',
        checked: false
    },
    {
        label: strings.date_picker_options_48hour_label,
        value: '48hour',
        checked: true
    },
    {
        label: strings.date_picker_options_week_label,
        value: 'week',
        checked: false
    },
    {
        label: strings.date_picker_options_2weeks_label,
        value: '2weeks',
        checked: false
    },
    {
        label: strings.date_picker_options_month_label,
        value: 'month',
        checked: false
    },
    {
        label: strings.date_picker_options_custom_label,
        value: 'custom',
        checked: false
    }
];

export const DATE_PICKER_OPTIONS_INDEX_FOR_CUSTOM = 6;
export const DATE_PICKER_OPTIONS_INDEX_FOR_DEFAULT_48_HOUR = 2;


export const COACHING_REVIEW_EVENTS_SORT_DIRECTION = {
    VEHICLE_ASCENDING: "ASCENDING",
    VEHICLE_DESCENDING: "DESCENDING"
}

export const COACHING_REVIEW_EVENTS_SORT_OPTIONS_NAMES = {
    CHRONOLOGICAL: "CHRONOLOGICAL",
    VEHICLE: "VEHICLE",
    VEHICLE_DRIVER: "VEHICLE_DRIVER",
    DRIVER: "DRIVER",
    DRIVER_VEHICLE: "DRIVER_VEHICLE"
}

export const COACHING_REVIEW_EVENTS_SORT_OPTIONS = [
    {
        label: strings.reports_sort_by_default_chronological,
        value: 'CHRONOLOGICAL',
        checked: true
    },
    {
        label: strings.reports_groups_options_vehicle_label,
        value: 'VEHICLE',
        checked: false
    },
    {
        label: strings.reports_groups_options_vehicle_then_driver_label,
        value: 'VEHICLE_DRIVER',
        checked: false
    },
    {
        label: strings.reports_groups_options_driver_label,
        value: 'DRIVER',
        checked: false
    },
    {
        label: strings.reports_groups_options_driver_then_vehicle_label,
        value: 'DRIVER_VEHICLE',
        checked: false
    }

];

export const COACHING_REVIEW_EVENTS_SORT_OPTIONS_NO_FACIAL_RECOGNITION = [
    {
        label: strings.reports_sort_by_default_chronological,
        value: 'CHRONOLOGICAL',
        checked: true
    },
    {
        label: strings.reports_groups_options_vehicle_label,
        value: 'VEHICLE',
        checked: false
    }
];

export const UNKNOWN_DRIVER_NAME_PLACEHOLDER = "UNKNOWN_DRIVER_NAME_PLACEHOLDER";
